require('../../fhApp/transformResource');

angular.module('app.admin.rosters.rosterService', [
  'app.transformResource'
])
  .factory('app.admin.rosters.rosterService', [
    '$http', 'app.transformResource',
    function ($http, transformResource) {
      "use strict";

      let transformRoster = function (roster) {
        roster.iisstarter = !!roster.iisstarter;
        roster.iisinactive = !!roster.iisinactive;

        return roster;
      };

      return {
        getLeagues: function () {
          return $http.get(window.location.api('rosters_leagues'));
        },
        getTeams: function (league_id) {
          return $http.get(window.location.api('rosters_leagues/' + league_id));
        },
        getRoster: function (team_id) {
          return $http({
            url: window.location.api('teams/' + team_id + '/roster'),
            method: 'GET',
            transformResponse: transformResource.onResponse(
              function (data) {
                if (Array.isArray(data.roster)) {
                  for (let i in data.roster) {
                    if (data.roster.hasOwnProperty(i)) {
                      data.roster[i] = transformRoster(data.roster[i]);
                    }
                  }
                }
                return data;
              }
            )
          });
        },
        updateRoster: function (roster_id, data) {
          return $http({
            url: window.location.api('rosters/' + roster_id),
            method: 'PUT',
            data: data,
            transformResponse: transformResource.onResponse(
              function (data) {
                data = transformRoster(data);
                return data;
              }
            )
          });
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/rosters/rosterService.js